import React, { useState, useEffect } from "react";

import { 
    GoogleMapsApiKey, 
    AreaWidthValue,
    DefaultLat,
    DefaultLng,
    DefaultListZoom
  } from "../../pages/SEGMENT/poseidon/GeoSegmentModel";
import { geoSegment_useStyles } from "../../atom/Apollo_styles";
import { RightDrawer } from "../../molecule/Apollo_RightDrawer";

import Button from "@material-ui/core/Button";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Grid from "@material-ui/core/Grid";

import { GoogleMap, Marker, Circle, useJsApiLoader } from "@react-google-maps/api";

// @ts-ignore
export const AreaSetting: React.FC<{ 
    geoSegments: any,
    geoSegmentId: number,
    geoSegmentName: string,
    description: string,
    closeInformation: any,
   }> = 
    ({ 
      geoSegments,
      geoSegmentId,
      geoSegmentName,
      description,
      closeInformation,
    }) => 
  {
    const geo_classes = geoSegment_useStyles();
  
    const [areaChangeFlg, setAreaChangeFlg] = useState(false);
    const [mapMarkers, setMapMarkers] = useState([{}]);
    const [areaLists, setAreaLists] = useState([{}]);
  
    const [mapSetting, setMapSetting] = useState({
      center: { 
        lat: DefaultLat,
        lng: DefaultLng
      }, 
      areaWidth: Number(AreaWidthValue.R75), 
      zoom: DefaultListZoom
    });
  
    // Google Maps Option
    // ------
    const mapOptions = {
      disableDefaultUI: true,
      zoomControl: true,
    };
  
    const circleOptions1 = {
      strokeColor: "#FFFFFF",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#FF0000",
      fillOpacity: 0.35,
      clickable: false,
      draggable: false,
      editable: false,
      visible: true,
      zIndex: 1,
    };
  
    const circleOptions2 = {
      strokeColor: "#FFFFFF",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#00CFFA",
      fillOpacity: 0.35,
      clickable: false,
      draggable: false,
      editable: false,
      visible: true,
      zIndex: 1,
    };
  
    const containerStyle = {
      height: "350px",
      width: "100%",
    };
  
    // google-map-script 読み込み
    const {isLoaded} = useJsApiLoader({
      id: 'google-map-script',
      googleMapsApiKey: GoogleMapsApiKey,
      libraries: ["places"]
    });

    useEffect(() => {
      geoSegments.map((geoSegment: any) => {
        if (geoSegment.id !== geoSegmentId) {
          return;
        }

        const newMapMarkers = [...mapMarkers];
        newMapMarkers.splice(0,1);
        setMapMarkers(newMapMarkers);

        const newAreaLists = [...areaLists];
        newAreaLists.splice(0,1);
        setAreaLists(newAreaLists);

        geoSegment.geoPoints.map((geoPointId: any) => {
          setMapMarkers(mapMarkers => [...mapMarkers,{ 
            center: {
              lat: Number(geoPointId.latitude), 
              lng: Number(geoPointId.longitude), 
            },
            areaWidth: Number(geoPointId.areaWidth),
            options: circleOptions1
          }]);

          setAreaLists(areaLists => [...areaLists,{ 
            lat: Number(geoPointId.latitude), 
            lng: Number(geoPointId.longitude),
            address: geoPointId.address,
            areaWidth: Number(geoPointId.areaWidth),
          }]);
        });
      });
    }, []);
  
    const formatAreaWidth = (areaWidth: any) => {
      let returnAreaWidth = areaWidth + "m";
      if (Number(areaWidth) >= 1000) {
        returnAreaWidth = (Number(areaWidth) / 1000) + "km"
      }
  
      return returnAreaWidth;
    }

    // マップピン・サークル削除
    function clearMapMarker() {
      mapMarkers.map((mapMarker: any, index: number) => {
        mapMarkers[index] = { 
          center: {
            lat: mapMarker.center.lat, 
            lng: mapMarker.center.lng, 
          },
          areaWidth: Number(mapMarker.areaWidth),
          options: circleOptions1
        };
      });
    }
  
    const onListClick = (e: any, index: number, areaList: any) => {
      let listItemElements = document.getElementsByClassName("areaListItem");
      for (let element in listItemElements){
        if (isNaN(Number(element))) {
          continue;
        }
        listItemElements[element].setAttribute('style', 'background: white');
      }

      clearMapMarker();
      mapMarkers[index] = { 
        center: {
          lat: Number(areaList.lat), 
          lng: Number(areaList.lng), 
        },
        areaWidth: Number(areaList.areaWidth),
        options: circleOptions2
      };
  
      setMapSetting({ 
        center: { 
          lat: Number(areaList.lat), 
          lng: Number(areaList.lng) 
        }, 
        areaWidth: Number(areaList.areaWidth),
        zoom: DefaultListZoom
      });
      setAreaChangeFlg(!areaChangeFlg);
  
      let listItemId = document.getElementById("areaListItem"+index);
      listItemId?.setAttribute('style', 'background: #FEF2E4');
    }
  
    return (
      <RightDrawer>
        <h1 className={geo_classes.areaSetting_h1}>
          ジオセグメント・エリア表示
        </h1>
        <div>
          <table className={geo_classes.areaSetting_half_width}>
            <tr>
              <th className={geo_classes.areaSetting_th}>
                ジオセグメント名
              </th>
              <td className={geo_classes.areaSetting_td1}>
                {geoSegmentName}
              </td>
            </tr>
            <tr>
              <th className={geo_classes.areaSetting_th}>
                説明
              </th>
              <td className={geo_classes.areaSetting_td1}>
                {description}
              </td>
            </tr>
            <tr>
              <th className={geo_classes.areaSetting_th}>
                タイプ
              </th>
              <td className={geo_classes.areaSetting_td1}>
                リアルタイム
              </td>
            </tr>
          </table>
          <div></div>
        </div>
        <p>エリア設定</p>
        <hr className={geo_classes.areaSetting_hr} />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <p style={{ marginTop: "10px" }}>エリア一覧</p>
            <div style={{ height: "400px", overflow: "scroll" }}>
              <List id="areaList">
                {
                  areaLists ?
                  areaLists.map((areaList2: any, index: number) =>
                    <ListItem 
                      key={index}
                      id={`areaListItem${index}`} 
                      className="areaListItem" 
                      onClick={(e) => onListClick(e, index, areaList2)}
                    >
                      <div>
                        <span className="areaAddress" style={{ fontSize: "10px", marginRight: "5px", width: "100px" }}>{areaList2.address}</span>
                        <br />
                        <span style={{ fontSize: "10px" }}>{`半径 ${formatAreaWidth(areaList2.areaWidth)}`}</span>
                      </div>
                    </ListItem>
                  )
                  : ""
                }
              </List>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div style={{ padding: "5px" }}>
              {isLoaded ? 
                <GoogleMap
                  key={areaChangeFlg ? "Loading" : "Loaded"}
                  mapContainerStyle={containerStyle}
                  center={mapSetting.center}
                  zoom={mapSetting.zoom}
                  options={mapOptions}
                >
                  {
                    mapMarkers ?
                    mapMarkers.map((mapMarker: any, index: number) =>
                      <span>
                        <Marker key={index} position={mapMarker.center} />
                        <Circle key={areaChangeFlg ? "Loading" : "Loaded"} center={mapMarker.center} radius={mapMarker.areaWidth} options={mapMarker.options} />
                      </span>
                    )
                    : ""
                  }
                </GoogleMap>
              : ""}
            </div>
          </Grid>
        </Grid>
        <Button 
          variant="contained" 
          style={{padding: "10px", fontSize: "15px", color: "white", background: "#FB6542"}}
          onClick={() => closeInformation()}
        >
          閉じる
        </Button>
      </RightDrawer>
    );
};